import type { RangeFilter } from '@src/models/interfaces/general/ElasticQueryParams.interface';
import { DateUtil } from '@src/packages/utils/dates';

/**
 * Elastic range for the current calendar day in the app timezone.
 * Uses date math so Elasticsearch resolves the day boundary server-side
 * (validated in Kibana against `attendance_dashboard`).
 */
export const buildCurrentDayRange = (): RangeFilter => ({
  gte: 'now/d',
  lt: 'now+1d/d',
  time_zone: DateUtil.getDefaultTimeZone(),
});

export const timestampSecondsOrNull = (
  value: { _seconds?: number } | null | undefined,
): number | null => (typeof value?._seconds === 'number' ? value._seconds : null);
